var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"outerListContainerCard"},[_c('resize-observer',{on:{"notify":_vm.onResizeComponent}}),_vm._v(" "),(_vm.displayComponent('CheckListItemTile'))?_c('CheckListItemTile',{attrs:{"object":_vm.object,"is-compact-view":_vm.isCompactView}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }